import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './../../styles/profesional/metodo-de-pago.css';
import * as globals from './../../components/GlobalScripts.js';
import Sidebar_left from './Sidebar_left';
import { Link } from 'react-router-dom';

const Profesional_MetodoDePago = () => {
    let path_api = localStorage.getItem('path_api');
    const [user, setUser] = useState([]);
    const [formDataPaymentMethod, setFormDataPaymentMethod] = useState({
        tipo: 'Transferencia',
        metodo: 'Clabe interbancaria',
        numero: '',
    });

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            let userParsed = JSON.parse(user_cache);
            setUser(userParsed);

            if (userParsed.payment_method) {
                setFormDataPaymentMethod(userParsed.payment_method);
            }
        }
    }, []);

    const handleSubmit_PaymentMethod = async (e) => {
        e.preventDefault();
        if (!/^\d{18}$/.test(formDataPaymentMethod.numero)) {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "El número de pago debe contener unicamente 18 dígitos.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
            return;
        }
        globals.openViewCharge();
        axios.post(`${path_api}/update-account/payment-method.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            paymentMethod: formDataPaymentMethod,
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Éxito",
                    msg: "El método de pago se actualizó correctamente.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                localStorage.setItem('user', JSON.stringify(response.data.user));
                setFormDataPaymentMethod(response.data.user.payment_method);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "El método de pago no se pudo actualizar.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al actualizar el método de pago.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };


    const handleChange_PaymentMethod = (e) => {
        const { name, type, checked, value } = e.target;
        const newValue = type === "checkbox" ? checked : value;
        setFormDataPaymentMethod({ ...formDataPaymentMethod, [name]: newValue });
    };


    return (
        <>
            <div className='container-profesional page-metodo-de-pago container-section'>
                <div className='left-side'>
                    <Sidebar_left />
                </div>
                <div className="right-side">
                    <form onSubmit={handleSubmit_PaymentMethod} className="flex-column gap-20">
                        <div className='sticky-form'>
                            <button className="button-primary" type="submit">Guardar</button>
                        </div>
                        <h2>Metodo de págo</h2>
                        <h5>¿Cómo recibiras tu dinero?</h5>

                        <div className="form-group">
                            <label htmlFor="tipo">Tipo de transacción</label>
                            <select
                                id="tipo"
                                name="tipo"
                                value={formDataPaymentMethod.tipo}
                                onChange={handleChange_PaymentMethod}
                                className="input-primary"
                                required
                            >
                                <option value="Transferencia">Transferencia</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label htmlFor="metodo">Metodo de entrega</label>
                            <select
                                id="metodo"
                                name="metodo"
                                value={formDataPaymentMethod.metodo}
                                onChange={handleChange_PaymentMethod}
                                className="input-primary"
                                required
                            >
                                <option value="Clabe interbancaria">Clabe interbancaria</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label htmlFor="numero">Número</label>
                            <input
                                type="text"
                                id="numero"
                                name="numero"
                                value={formDataPaymentMethod.numero}
                                onChange={handleChange_PaymentMethod}
                                className="input-primary"
                                placeholder="18 dígitos"
                                required
                                pattern="\d{1,18}"
                                maxLength="18"
                            />
                        </div>

                    </form>
                </div>
            </div>
        </>
    );
};

export default Profesional_MetodoDePago;
